import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css';

function LoadingSpinner({ message, fullScreen = false }) {
  const { t } = useTranslation();
  const displayMessage = message != null && message !== '' ? message : t('common.loading');
  const containerClass = fullScreen ? 'loading-spinner-fullscreen' : 'loading-spinner-container';
  
  return (
    <div className={containerClass}>
      <div className="loading-spinner">
        <div className="loading-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        {displayMessage && <p className="loading-message">{displayMessage}</p>}
      </div>
    </div>
  );
}

export default LoadingSpinner;
